import { consoleLogger } from '../ports/logger.js';
import { ensureAssetCached } from './ensure-asset.js';
/**
 * Download manifesto + assets, SHA-256 verify, stage into cache.
 *
 * Signage rule: if at least one item verifies, stage a *partial* playlist with
 * only those items so a single bad video cannot leave the TV on
 * "Paired — waiting for content" forever while images would have played.
 * Returns null only when every item fails (or the manifest is empty).
 */
export async function ensurePlaylistCached(input) {
    const existing = input.cache.get(input.ref);
    if (existing)
        return existing;
    const logger = input.logger ?? consoleLogger;
    const manifest = await input.api.getManifest(input.token, {
        playlistId: input.ref.playlistId,
        version: input.ref.version,
    });
    if (manifest.items.length === 0)
        return null;
    const verifiedItems = [];
    const verifiedAssetIds = [];
    for (const item of manifest.items) {
        const result = await ensureAssetCached({
            store: input.assets,
            hasher: input.hasher,
            api: input.api,
            item,
        });
        if (result.ok) {
            verifiedItems.push(item);
            verifiedAssetIds.push(item.assetId);
            continue;
        }
        logger.warn('Playlist item failed cache verify — skipping', {
            assetId: item.assetId,
            reason: result.reason,
            playlistId: input.ref.playlistId,
            version: input.ref.version,
        });
    }
    if (verifiedItems.length === 0)
        return null;
    const cached = {
        ref: input.ref,
        manifest: { ...manifest, items: verifiedItems },
        verifiedAssetIds,
    };
    input.cache.stage(cached);
    return cached;
}
//# sourceMappingURL=ensure-cached.js.map